/* eslint-disable */
export default {
  createLog: 'Créer un journal',
  creating: 'Création',
  save: 'Enregistrer',
  saving: 'Enregistrement',
  saved: 'Sauvegardé',
  view: 'Afficher',
  creatingFailed: 'La création a échoué.',
  savingFailed: 'L’enregistrement a échoué.',
} as const;

// @key: @#@"createLog"@#@ @source: @#@"Create Log"@#@
// @key: @#@"creating"@#@ @source: @#@"Creating"@#@
// @key: @#@"save"@#@ @source: @#@"Save"@#@
// @key: @#@"saving"@#@ @source: @#@"Saving"@#@
// @key: @#@"saved"@#@ @source: @#@"Saved"@#@
// @key: @#@"view"@#@ @source: @#@"View"@#@
// @key: @#@"creatingFailed"@#@ @source: @#@"Creating failed."@#@
// @key: @#@"savingFailed"@#@ @source: @#@"Saving failed."@#@
